/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DayOfWeek } from './DayOfWeek';
import {
    DayOfWeekFromJSON,
    DayOfWeekFromJSONTyped,
    DayOfWeekToJSON,
    DayOfWeekToJSONTyped,
} from './DayOfWeek';
import type { AppointmentAvailability } from './AppointmentAvailability';
import {
    AppointmentAvailabilityFromJSON,
    AppointmentAvailabilityFromJSONTyped,
    AppointmentAvailabilityToJSON,
    AppointmentAvailabilityToJSONTyped,
} from './AppointmentAvailability';
import type { AttendanceType } from './AttendanceType';
import {
    AttendanceTypeFromJSON,
    AttendanceTypeFromJSONTyped,
    AttendanceTypeToJSON,
    AttendanceTypeToJSONTyped,
} from './AttendanceType';
import type { TimeDate } from './TimeDate';
import {
    TimeDateFromJSON,
    TimeDateFromJSONTyped,
    TimeDateToJSON,
    TimeDateToJSONTyped,
} from './TimeDate';

/**
 * 
 * @export
 * @interface AttendanceEntryRequest
 */
export interface AttendanceEntryRequest {
    /**
     * 
     * @type {DayOfWeek}
     * @memberof AttendanceEntryRequest
     */
    weekday: DayOfWeek;
    /**
     * 
     * @type {string}
     * @memberof AttendanceEntryRequest
     */
    purposeKey: string;
    /**
     * 
     * @type {AttendanceType}
     * @memberof AttendanceEntryRequest
     */
    attendanceType: AttendanceType;
    /**
     * 
     * @type {AppointmentAvailability}
     * @memberof AttendanceEntryRequest
     */
    availability: AppointmentAvailability;
    /**
     * 
     * @type {TimeDate}
     * @memberof AttendanceEntryRequest
     */
    startTime: TimeDate;
    /**
     * 
     * @type {TimeDate}
     * @memberof AttendanceEntryRequest
     */
    endTime: TimeDate;
    /**
     * 
     * @type {string}
     * @memberof AttendanceEntryRequest
     */
    details: string | null;
    /**
     * 
     * @type {string}
     * @memberof AttendanceEntryRequest
     */
    substituteCounselorId: string | null;
}



/**
 * Check if a given object implements the AttendanceEntryRequest interface.
 */
export function instanceOfAttendanceEntryRequest(value: object): value is AttendanceEntryRequest {
    if (!('weekday' in value) || value['weekday'] === undefined) return false;
    if (!('purposeKey' in value) || value['purposeKey'] === undefined) return false;
    if (!('attendanceType' in value) || value['attendanceType'] === undefined) return false;
    if (!('availability' in value) || value['availability'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    if (!('substituteCounselorId' in value) || value['substituteCounselorId'] === undefined) return false;
    return true;
}

export function AttendanceEntryRequestFromJSON(json: any): AttendanceEntryRequest {
    return AttendanceEntryRequestFromJSONTyped(json, false);
}

export function AttendanceEntryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttendanceEntryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'weekday': DayOfWeekFromJSON(json['weekday']),
        'purposeKey': json['purposeKey'],
        'attendanceType': AttendanceTypeFromJSON(json['attendanceType']),
        'availability': AppointmentAvailabilityFromJSON(json['availability']),
        'startTime': TimeDateFromJSON(json['startTime']),
        'endTime': TimeDateFromJSON(json['endTime']),
        'details': json['details'],
        'substituteCounselorId': json['substituteCounselorId'],
    };
}

export function AttendanceEntryRequestToJSON(json: any): AttendanceEntryRequest {
    return AttendanceEntryRequestToJSONTyped(json, false);
}

export function AttendanceEntryRequestToJSONTyped(value?: AttendanceEntryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'weekday': DayOfWeekToJSON(value['weekday']),
        'purposeKey': value['purposeKey'],
        'attendanceType': AttendanceTypeToJSON(value['attendanceType']),
        'availability': AppointmentAvailabilityToJSON(value['availability']),
        'startTime': TimeDateToJSON(value['startTime']),
        'endTime': TimeDateToJSON(value['endTime']),
        'details': value['details'],
        'substituteCounselorId': value['substituteCounselorId'],
    };
}

